module.exports = __webpack_public_path__ + "img/brand_top@2x.aaed976a.png";